import React from 'react';

const IconCheck = ({ className }) => (
  <svg
    className={className}
    width="16"
    height="11"
    viewBox="0 0 16 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M1.46973 5.67012L5.60306 9.80345L14.5364 0.870117" stroke="white" strokeWidth="1.5" />
  </svg>
);

export default IconCheck;
